var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeatherStationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Weather Station Icon 1",
    clipPath: "url(#clip0_9628_22018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vertical-bar",
    d: "M12.6699 16.1772V2.61719",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "horizontal-bar",
    d: "M9.32996 2.61719H16",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "dot-over-arrow-2",
    d: "M18.0199 4.77C19.13 4.77 20.0299 3.87009 20.0299 2.76C20.0299 1.64991 19.13 0.75 18.0199 0.75C16.9098 0.75 16.0099 1.64991 16.0099 2.76C16.0099 3.87009 16.9098 4.77 18.0199 4.77Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "dot-over-arrow",
    d: "M7.30993 4.77C8.42002 4.77 9.31993 3.87009 9.31993 2.76C9.31993 1.64991 8.42002 0.75 7.30993 0.75C6.19983 0.75 5.29993 1.64991 5.29993 2.76C5.29993 3.87009 6.19983 4.77 7.30993 4.77Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "bar-in-middle-arrow",
    d: "M0.939941 10.2266H12.6699",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "wind-arrow",
    d: "M7.58994 10.2269L9.79994 13.1569H3.14994L0.939941 10.2269L3.14994 7.29688H9.79994L7.58994 10.2269Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9628_22018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.78,
    height: 16.18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherStationIcon);
export default __webpack_public_path__ + "static/media/weather-station-icon.7b9eb5251fb0bde48c704b38e7544490.svg";
export { ForwardRef as ReactComponent };